import React from 'react';

const MiniCalendar = ({ year, month, highlights, selectedDate, onSelectDate }) => {
  const weeks = [];
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  let week = Array(firstDay.getDay()).fill(null);

  for (let d = 1; d <= lastDay.getDate(); d++) {
    week.push(d);
    if (week.length === 7) {
      weeks.push(week);
      week = [];
    }
  }
  if (week.length) {
    week = [...week, ...Array(7 - week.length).fill(null)];
    weeks.push(week);
  }

  // Helper pour formater les dates
  const pad2 = (n) => n.toString().padStart(2, '0');
  
  return (
    <div className="mini-calendar-grid">
      {['D','L','M','M','J','V','S'].map((d, i) => (
        <div key={i} className="mc-header">{d}</div>
      ))}

      {weeks.map((wk, wi) =>
        wk.map((day, di) => {
          const dateStr = day
            ? `${year}-${pad2(month + 1)}-${pad2(day)}`
            : null;
            
          const isHighlighted = day && highlights.includes(dateStr);
          const isSelected = dateStr === selectedDate;

          return (
            <div
              key={`${wi}-${di}`}
              className={`mc-cell ${isSelected ? 'mc-cell--selected' : ''} ${!day ? 'mc-cell--empty' : ''}`}
              onClick={() => {
                if (dateStr && isHighlighted) {
                  onSelectDate(dateStr);
                }
              }}
            >
              {day && <span className="mc-day">{day}</span>}
              {isHighlighted && <span className="mc-dot" />}
            </div>
          );
        })
      )}
    </div>
  );
};

export default MiniCalendar;